const SALES_TAX_DEAL_TYPE = {
    REGULAR_DEALS: 'Regular Deals',
    LEASE_DEALS: 'Lease Deals',
};

export default SALES_TAX_DEAL_TYPE;
